import React from "react";
import {Badge, Table, Tag} from "antd";

import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {TableContainer} from "./ResponsiveDataTable.styles";
import {courierStatusColors, courierStatuses} from "../../../constants/constants";
import {getConstant, isConstantExist} from "../../../utils/helpers";
import moment from "moment";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {useStore} from "../../../hooks/useStore";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";

const TABLE_PREFIX = "availableCouriersTable";

const ResponsiveDataTable = ({data = [], loading, currentPage, setCurrentPage, dataCount}) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    const courierStatusSorter = (a, b) => {
        const courierStatusesIndex = [
            "ready",
            "available",
            "assigned",
            "waitingForCourier",
            "busy",
            "unavailable"
        ];

        return courierStatusesIndex.indexOf(a.status) - courierStatusesIndex.indexOf(b.status);
    };
    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                pagination={
                    false /* {
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                } */
                }
                rowKey="id"
                rowClassName="hello"
                dataSource={data}
                data-testid="availableCourierDataTable"
                size="small"
                scroll={{x: "max-content"}}
                style={{width: "100%"}}
                loading={loading}
                locale={{
                    emptyText: <EmptyMessage />
                }}
            >
                <Table.Column
                    title="Kurye Adı"
                    dataIndex="name"
                    key="name"
                    sorter={(a, b) => a.name.localeCompare(b.name, "tr")}
                    render={(name, record) => (
                        <a
                            onClick={() => window.open(`/couriers/${record.id}`, "_blank")}
                            style={{ cursor: 'pointer' }}
                        >
                            <b>{name}</b>
                        </a>
                    )}
                />
                <Table.Column
                    title={<span style={{ fontWeight: 'bold' }}>Atanabilir Mi?</span>}
                    dataIndex="isEligible"
                    key="isEligible"
                    render={isEligible => (
                        <span style={{ 
                            color: isEligible ? '#52c41a' : '#ff4d4f',
                            display: 'flex',
                            justifyContent: 'center',
                            fontSize: '20px'
                        }}>
                            {isEligible ? 
                                <CheckOutlined style={{ strokeWidth: 50 }} className="anticon-check" /> : 
                                <CloseOutlined style={{ strokeWidth: 50 }} className="anticon-close" />
                            }
                        </span>
                    )}
                />
                <Table.Column
                    title="Kuryenin Vardiyası Var Mı?"
                    dataIndex="hasShift"
                    key="hasShift"
                    render={hasShift => (
                        <Tag color={hasShift ? "green" : "red"}>
                            {hasShift ? "Evet" : "Hayır"}
                        </Tag>
                    )}
                />
                <Table.Column
                    title="Durum"
                    dataIndex="status"
                    key="status"
                    sorter={courierStatusSorter}
                    defaultSortOrder={"ascend"}
                    render={status => (
                        <Tag data-testid="courierStatus">
                            <Badge
                                data-testid="courierStatus_badge"
                                data-testvalue={Boolean(status)}
                                color={courierStatusColors[status]}
                            />
                            {isConstantExist(courierStatuses, status)
                                ? t(getConstant(courierStatuses, status).translation_key, {
                                      ns: "courierStatuses"
                                  })
                                : "-"}
                        </Tag>
                    )}
                />
                <Table.Column
                    title="Kurye Üstünde Zorunlu Sipariş Var Mı?"
                    dataIndex="isForced"
                    key="isForced"
                    render={isForced => (
                        <Tag color={isForced ? "green" : "red"}>
                            {isForced ? "Evet" : "Hayır"}
                        </Tag>
                    )}
                />
                <Table.Column
                    title="Kurye Maksimum Uzaklık Sınırı İçinde Mi?"
                    dataIndex="isFar"
                    key="isFar"
                    render={isFar => (
                        <Tag color={isFar ? "red" : "green"}>
                            {isFar ? "Hayır" : "Evet"}
                        </Tag>
                    )}
                />
                <Table.Column
                    title="Uzaklık"
                    dataIndex="distance"
                    key="distance"
                    sorter={(a, b) => a?.distance - b?.distance}
                    render={distance => <>{distance?.toFixed(1)} km</>}
                />
                <Table.Column
                    title="Son Konum Tarihi"
                    dataIndex="lastLocationTime"
                    key="lastLocationTime"
                    sorter={(a, b) => moment(a.lastLocationTime).diff(moment(b.lastLocationTime))}
                    render={lastLocationTime => (
                        <>{moment(lastLocationTime).format("DD.MM.YYYY HH:mm")}</>
                    )}
                />
            </TableContainer>
        </>
    );
};

export default ResponsiveDataTable;
